// import "./socket"; // <-- Add this at the top
import { ApolloProvider } from "@apollo/client";
import { Provider as JotaiProvider } from "jotai/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { client } from "./apolloClient.ts";
import App from "./App.tsx";
import { ServiceWorkerCleanup } from "./components/ServiceWorkerCleanup";
import { reloadOnceForStaleChunk } from "./components/error-boundary/stale-chunk";
import AppToaster from "./components/toaster";
import { AuthGatedConversationSocket } from "./context/AuthGatedConversationSocket";
import { UserProvider } from "./context/UserContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { VersionProvider } from "./context/VersionContext";
import { CompanyFollowProvider } from "./context/CompanyFollowContext";
import { ConnectionStatusProvider } from "./context/ConnectionStatusContext";
import { PodcastUploadProvider } from "./context/PodcastUploadContext";

// Vite fires this when a lazy chunk 404s (stale tab after a deploy).
window.addEventListener("vite:preloadError", (event) => {
  // Second failure in a row: let the error reach the ErrorBoundary so the screen shows.
  if (reloadOnceForStaleChunk()) event.preventDefault();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ApolloProvider client={client}>
      <ServiceWorkerCleanup />
      <VersionProvider>
        <JotaiProvider>
          <UserProvider>
            <SubscriptionProvider>
              <CompanyFollowProvider>
                <ConnectionStatusProvider>
                  <AuthGatedConversationSocket>
                    {/* Outside the route tree so background uploads survive navigation */}
                    <PodcastUploadProvider>
                      <App />
                    </PodcastUploadProvider>
                    <AppToaster />
                  </AuthGatedConversationSocket>
                </ConnectionStatusProvider>
              </CompanyFollowProvider>
            </SubscriptionProvider>
          </UserProvider>
        </JotaiProvider>
      </VersionProvider>
    </ApolloProvider>
  </StrictMode>,
);
